import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult } from 'react-query';
import { ErrorMessage, InvoiceSend } from 'types';
import { client } from 'utils/api-client';

export default function useSendInvoice(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  InvoiceSend
> {
  const sendInvoice = (payload: InvoiceSend): Promise<AxiosResponse<null>> => {
    return client.post(`invoices/${payload.invoiceId}/send-invoice/`, payload);
  };

  return useMutation(sendInvoice);
}
